//#region src/assets/vana-quotas-white-logo.svg
var vana_quotas_white_logo_default = "" + new URL("vana-quotas-white-logo-kPzbe5bF.svg", import.meta.url).href;
//#endregion
export { vana_quotas_white_logo_default as default };

//# sourceMappingURL=vana-quotas-white-logo.js.map